import {Path, position} from './typings';
import {getCurrentCard} from './getCurrentCard';

/* eslint-disable max-statements */
export const getRemovePath = (editor: any, at: position, builderId: string) => {
    if (Array.isArray(at)) {
        return at;
    }
    let removePath: Path = [];
    const hasCardNode = editor.children.some((node: any) => node.type === 'card');
    switch (at) {
        case 'start':
            removePath = hasCardNode ? [1, 0, 0] : [1];
            break;
        case 'end': {
            const lastNode = editor.children[editor.children.length - 1];
            if (lastNode.type === 'card') {
                removePath = [editor.children.length - 1, 0, lastNode.children[0].children.length - 1];
            }
            else {
                removePath = [editor.children.length];
            }
            break;
        }
        case 'cardStart': {
            const currentCard = getCurrentCard(builderId);
            if (currentCard) {
                removePath = currentCard[1].concat(0, 0);
            }
            break;
        }
        case 'cardEnd': {
            const currentCard = getCurrentCard(builderId);
            if (currentCard) {
                removePath = currentCard[1].concat(0, currentCard[0].children[0].children.length - 1);
            }
            break;
        }
        case 'before': {
            const flexBuilderNode = editor.MorphoAPI.findNodeById(editor, builderId, 'builderId');
            if (flexBuilderNode && flexBuilderNode[1]) {
                removePath = flexBuilderNode[1].slice(0);
                removePath[removePath.length - 1]--;
                if (removePath[removePath.length - 1] < 0) {
                    // 前面没有结点了，不操作
                    removePath = [];
                }
            }
            break;
        }
        case 'after': {
            const flexBuilderNode = editor.MorphoAPI.findNodeById(editor, builderId, 'builderId');
            if (flexBuilderNode && flexBuilderNode[1]) {
                removePath = flexBuilderNode[1].slice(0);
                removePath[removePath.length - 1]++;
            }
            break;
        }
    }
    if (removePath.length === 0) {
        const entry = editor.MorphoAPI.findNodeById(editor, at);
        if (entry && entry[1]) {
            removePath = entry[1];
        }
    }
    return removePath;
};
